import React, { useRef, useState } from 'react';
import { combine } from '../../../../../helpers/styles';
import Icon from '../../../../ui/icon';
import * as styles from './styles.module.scss';
import AutoSuggestionItem from '../autoSuggestionItem';

// if clamp, return at most 20 wprds of the text that surrounds the term
const getFormattedSuggestion = (text, term, clamp) => {
  const re = new RegExp(decodeURIComponent(term), 'gi');

  if (clamp && text.length) {
    const words = text.split(' ');
    const index = words.findIndex((word) =>
      word.toLowerCase().includes(term.toLowerCase())
    );
    const start = index - 10 > 0 ? index - 10 : 0;
    const startEllipsis = start > 0 ? '...' : '';
    const end = index + 10;
    const endEllipsis = end < words.length ? '...' : '';
    return (
      startEllipsis +
      words
        .slice(start, index)
        .concat(words[index]?.replace(re, (match) => `<b>${match}</b>`))
        .concat(words.slice(index + 1, end).join(' '))
        .join(' ') +
      endEllipsis
    );
  }

  return text.replace(re, (match) => `<b>${match}</b>`);
};

const SearchField = ({
  placeholder,
  onReset,
  onChange,
  className,
  autoFocus,
  onBackdropClick,
  autoSuggestion = [],
  small,
  searchTerm,
  onItemClick,
}) => {
  const inputRef = useRef();
  const [isActive, setIsActive] = useState(false);

  const cleanInput = () => {
    onReset();
    inputRef.current.focus();
  };

  const handleBackDropClick = () => {
    setIsActive(false);
    if (onBackdropClick) {
      onBackdropClick();
    }
  };

  const handleItemClick = (index) => {
    setIsActive(false);
    onItemClick(index);
  };

  return (
    <>
      <div
        className={combine(
          styles.search,
          isActive && styles.isActive,
          className
        )}
      >
        <div className={styles.searchField}>
          <input
            type="text"
            name="search_field"
            placeholder={placeholder.toUpperCase()}
            className={combine(styles.searchInput, small && styles.small)}
            onChange={onChange}
            onFocus={() => setIsActive(true)}
            value={searchTerm}
            autoComplete="off"
            ref={inputRef}
            autoFocus={autoFocus}
            data-test="search-input"
          />
          {searchTerm && (
            <button
              type="button"
              onClick={cleanInput}
              className={styles.closeBtn}
              data-test="search-clean-btn"
            >
              <Icon
                name="backspace"
                size="3x"
                className={combine(styles.closeIcon, small && styles.small)}
              />
            </button>
          )}
        </div>

        {autoSuggestion && autoSuggestion.length > 0 && (
          <div className={styles.autoSuggestion}>
            {autoSuggestion.map((item) => (
              <AutoSuggestionItem
                key={item.headline}
                title={getFormattedSuggestion(item.headline, searchTerm)}
                content={getFormattedSuggestion(item.content, searchTerm, true)}
                onClick={() => handleItemClick(item.index)}
              ></AutoSuggestionItem>
            ))}
          </div>
        )}
      </div>
      <div
        className={combine(styles.backdrop, isActive && styles.isActive)}
        onClick={handleBackDropClick}
      />
    </>
  );
};

export default SearchField;
